import React from 'react';
//import { ASSETS_SERVER_PATH } from '../../../config/defaults';
//import Loading from '../../Loading';

function IframePlayer(props) {
	/*const [isLoading, setLoadingStatus] = React.useState(true);
	const [source, setSource] = React.useState(true);

	/*React.useEffect(() => {
		if (isLoading) {
			fetch(
				`https://eventovirtual-co.appspot.com/${props.sttk}/${props.streamId}/${props.startTime}/86400/PLAYER_SOURCE`,
				{ method: 'POST' }
			)
				.then((res) => res.text())
				.then((data) => {
					setSource(data);
					setLoadingStatus(false);
				});
		}
	}, [isLoading, props]);

	if (isLoading) {
		return <Loading isFullScren={false} />;
	}*/

	return (
		<div
			className="bitmovinplayer-container aspect-16x9"
			style={{
				height: `${props.iframeHeight}px`,
				position: 'relative',
				width: '100%',
			}}
			ref={props.playerContainer}
		>
			<iframe
				title="player"
				style={{ width: '100%', overflow: 'visible', height: '100%' }}
				allowFullScreen={true}
				width="100%"
				onLoad={() => props.onResize()}
				scrolling="no"
				frameBorder="0"
				src={`https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/events/${props.eventId}/player.html?id=${props.eventId}&st=${props.startTime}&autoplay=false`}
			></iframe>
		</div>
	);
}

export default IframePlayer;
